"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _actions = require("../actions");
var _redux = require("redux");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};
const mapDispatchToProps = dispatch => {
  return (0, _redux.bindActionCreators)({
    authenticate: _actions.authenticate,
    newPassword: _actions.newPassword,
    dispatch
  }, dispatch);
};
class NewPassword extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      password: ''
    });
    _defineProperty(this, "handleChange", event => {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;
      this.setState({
        [name]: value
      });
    });
    _defineProperty(this, "handleValid", valid => {
      this.setState({
        valid
      });
    });
    _defineProperty(this, "handleSubmit", event => {
      event.preventDefault();
      const {
        auth,
        history,
        dispatch,
        location
      } = this.props;
      this.props.newPassword(auth.user, this.state.password).then(() => {
        this.props.authenticate().then(response => {
          if (!location || !location.state) history.push(auth.onSignInRedirect);
          auth.onAuthenticateSuccess({
            history,
            dispatch,
            location
          }, response);
        });
      });
    });
    _defineProperty(this, "render", () => {
      const {
        children,
        auth
      } = this.props;
      const {
        password
      } = this.state;
      return _react.default.cloneElement(children, {
        onSubmit: this.handleSubmit,
        onChange: this.handleChange,
        onValid: this.handleValid,
        passwordRules: auth.passwordRules,
        error: auth.error,
        state: {
          password
        }
      });
    });
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NewPassword);
module.exports = exports.default;